import { normalizeProjectedStatKey } from "./selectionState";

const BOARD_STAT_LABEL_OVERRIDES = {
  pra: "Pts+Rebs+Asts",
  fta: "Free-throw Attempts",
  ftm: "Free-throws Made",
  "3pta": "3-point Attempts",
  "3ptm": "3-pointers Made",
  "2-pt_att": "2-point Attempts",
  "2-pt_made": "2-pointers Made",

  //  Baseball
  hrr: "Hits+Runs+RBIs",
  "hits+runs+rbis": "Hits+Runs+RBIs",
  tb: "Total Bases",
  ks: "Strikeouts",
  sb: "Stolen Bases",
  ha: "Hits Allowed",
  po: "Pitching Outs",
  "hitter_ks": "Hitter Strikeouts",
  // Soccer
  'sot': "Shots on Target",
  shots_on_goal: "Shots on Goal",
  shots_on_target: "Shots on Target",
  goalie_saves: "Saves",
};

const toBoardStatToken = (value) => {
  if (typeof value !== "string") {
    return "";
  }

  return normalizeProjectedStatKey(value.trim().toLowerCase())
    .replace(/^projected_/, "")
    .replace(/\s+/g, "_");
};

const titleCaseBoardStat = (label) =>
  label
    .split("+")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join("+");

export const formatBoardStatLabel = (statKey, rawLabel, options = {}) => {
  const fallbackLabel = options.fallbackLabel || "Stat";
  const popularLabel = options.popularLabel || "🔥 Popular";
  const statToken = toBoardStatToken(statKey);
  const labelToken = toBoardStatToken(rawLabel);

  if (statKey === "games") {
    return "Games";
  }

  if (statToken === "popular" || labelToken === "popular") {
    return popularLabel;
  }

  const override = BOARD_STAT_LABEL_OVERRIDES[labelToken] || BOARD_STAT_LABEL_OVERRIDES[statToken];
  if (override) {
    return override;
  }

  const baseLabel =
    typeof rawLabel === "string" && rawLabel.trim()
      ? rawLabel.trim()
      : statToken;

  if (!baseLabel) {
    return fallbackLabel;
  }

  return titleCaseBoardStat(baseLabel);
};
